const designSystemColors = {
  generalButtons: "#E04F28",
  secondaryButtons: "#022166",
  textGeneralButtons: "#FFF",
  disabledButtons: "#D5D7D9",
  cancelButtons: "#4A5157",

  textDark: "#000",
  sucessColor: "#52c41a",
  errorColor: "#b81414",
  warningColor: "#faad14",
  infoColor: "#5188F4",
  activateGreen: "#228B22",
  textDescription: "#393D42",
  grayChart: "#8c8c8c",

  lightOrange: "#FF6633",

  background: "#FFF",
};

export default designSystemColors;
